module.exports = __webpack_public_path__ + "img/3.cbb7ada7.jpg";